import React from 'react';
import { Modal, Input, Form, Button  } from 'hzero-ui';
import { Bind } from 'lodash-decorators';

import intl from 'utils/intl';
import { encryptPwd } from 'utils/utils';
import { validatePasswordRule } from './utils/resetPassWordValidator';
import notification from 'utils/notification';
import PasswordStrength from 'components/PasswordStrength';
import { HZERO_IAM } from 'utils/config';
import request from 'utils/request';
import { getPublicKey } from 'hzero-front/lib/services/api';
import { getCurrentUser, getResponse, getCurrentOrganizationId } from 'utils/utils';
import formatterCollections from 'utils/intl/formatterCollections';

const { Item: FormItem } = Form;
const formItemLayout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 19 },
};

@formatterCollections({
  code: ['srm.common', 'hzeo.common', 'hzero.common', 'hiam.userInfo', 'hiam.subAccount'],
})
@Form.create({ fieldNameProp: null })
export default class ResetPassWord extends React.Component {
  state = {
    passwordStrength: 0,
    confirmLoading: false,
    visible: false,
    currentUser: {},
    publicKey: '',
    passwordTipMsg: {},
  };

  componentDidMount() {
    this.setState({
      passwordStrength: 0,
      currentUser: getCurrentUser(),
    });
    this.getPasswordExpired();
    this.getPasswordRule();
    this.getPublicKey();
  }

  // 密码是否过期
  getPasswordExpired() {
    passwordExpired().then((res) => {
      const response = getResponse(res);
      if (response && response.expired) {
        this.setState({
          visible: true,
        });
      }
    }).catch((error) => {
      throw new Error(error);
    });
  }

  // 获取密码相关信息
  getPasswordRule() {
    getPasswordRule().then((res) => {
      const response = getResponse(res);
      if (response) {
        this.setState({
          passwordTipMsg: response,
        });
      }
    }).catch((error) => {
      throw new Error(error);
    });
  }

  // 获取公钥
  getPublicKey() {
    getPublicKey().then((res) => {
      const response = getResponse(res);
      if (response) {
        this.setState({
          publicKey: response.publicKey,
        });
      }
    }).catch((error) => {
      throw new Error(error);
    });
  }

  @Bind()
  saveBtnClick() {
    const { form } = this.props;
    const { passwordStrength, publicKey } = this.state;
    form.validateFields((err, values) => {
      if (!err) {
        if (passwordStrength < 4) {
          notification.warning({
            message: intl
              .get('hzero.common.view.message.passwordStrength')
              .d('密码强度不足，请按照密码要求填写'),
          });
          return;
        }
        this.setState({ confirmLoading: true });
        userInfoUpdatePassword({
          password: encryptPwd(values.password, publicKey),
          originalPassword: encryptPwd(values.originalPassword, publicKey),
        }).then((res) => {
          this.setState({ confirmLoading: false });
          const response = getResponse(res);
          if (response) {
            this.setState({
              visible: false,
            });
            dvaApp._store.dispatch({
              type: 'login/logout',
            });
          }
        }).catch((error) => {
          this.setState({ confirmLoading: false });
          throw new Error(error);
        });
      }
    });
  }

  /**
   * 检查 确认密码是否与密码一致
   * @param {String} rule
   * @param {String} value
   * @param {Function} callback
   */
  @Bind()
  validatePasswordRepeat(rule, value, callback) {
    const { form } = this.props;
    if (value && value !== form.getFieldValue('password')) {
      callback(
        intl.get('hiam.subAccount.view.validation.passwordSame').d('确认密码必须与密码一致')
      );
    } else {
      callback();
    }
  }

  /**
   * 检查 确认密码是否与密码一致
   */
  @Bind()
  validatePasswordRepeatForPassword(e) {
    const { form } = this.props;
    const anotherPassword = form.getFieldValue('anotherPassword');
    const anotherPasswordField = {
      value: anotherPassword,
    };
    if (e.target.value) {
      if (e.target.value === anotherPassword) {
        anotherPasswordField.errors = null;
      } else {
        anotherPasswordField.errors = [
          new Error(
            intl.get('hiam.subAccount.view.validation.passwordSame').d('确认密码必须与密码一致')
          ),
        ];
      }
    } else {
      anotherPasswordField.errors = null;
    }
    form.setFields({
      anotherPassword: anotherPasswordField,
    });
  }

  /**
   * 检查 新密码与原密码不能相同
   * @param {String} rule
   * @param {String} value
   * @param {Function} callback
   */
  @Bind()
  validateNewPasswordNotSame(value, callback, form) {
    if (value && value === form.getFieldValue('originalPassword')) {
      callback(
        intl.get('hiam.subAccount.view.validation.passwordNoSame').d('新密码不能与原密码相同')
      );
    } else {
      callback();
    }
  }

  /**
   * validatePasswordAnther - 验证 新密码 和 确认密码 相同
   * @param {String} value - 新的密码
   * @param {Function} callback - 校验失败 需要回调错误， 否则空的回调
   * @param {Object} form - 表单
   * @memberof UserInfo
   */
  @Bind()
  validatePasswordAnther(value, callback, form) {
    if (value && value !== form.getFieldValue('password')) {
      callback(intl.get('hiam.userInfo.view.validation.passwordSame').d('确认密码必须与密码相同'));
    } else {
      callback();
    }
  }

  @Bind()
  gotoLogin() {
    dvaApp._store.dispatch({
      type: 'login/logout',
    });
  }

  render() {
    const { form } = this.props;
    const { confirmLoading, currentUser, visible, passwordTipMsg } = this.state;
    const { loginName } = currentUser;
    const { getFieldDecorator } = form;
    return (
      <Modal
        destroyOnClose
        confirmLoading={confirmLoading}
        width={620}
        visible={visible}
        footer={[
          <Button key="gotoLogin" onClick={this.gotoLogin}>
            {intl.get('srm.oauth.register.returnToLogin').d('返回登录')}
          </Button>,
          <Button key="submit" type="primary" loading={confirmLoading} onClick={this.saveBtnClick}>
            {intl.get('hzero.common.button.confirm').d('确认')}
          </Button>,
        ]}
        zIndex={9999}
        closable={false}
        keyboard={false}
        title={intl.get('hiam.subAccount.view.option.passwordUpdate').d('修改密码')}
      >
        <FormItem
          required
          key="originalPassword"
          label={intl.get('hiam.userInfo.model.user.originalPassword').d('原密码')}
          {...formItemLayout}
        >
          {getFieldDecorator('originalPassword', {
            validateTrigger: 'onBlur',
            rules: [
              {
                required: true,
                message: intl.get('hzero.common.validation.notNull', {
                  name: intl.get('hiam.userInfo.model.user.originalPassword').d('原密码'),
                }),
              },
              {
                max: 110,
                message: intl.get('hzero.common.validation.max', {
                  max: 110,
                }),
              },
            ],
            // 密码字段自动填充 https://developer.mozilla.org/zh-CN/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
          })(
            <Input
              type="password"
              autoComplete="new-password"
              onChange={() => {
                setTimeout(() => {
                  form.validateFields(['password'], { force: true });
                });
              }}
            />
          )}
        </FormItem>
        <FormItem
          required
          key="password"
          label={intl.get('hiam.userInfo.model.user.password').d('密码')}
          {...formItemLayout}
        >
          {getFieldDecorator('password', {
            rules: [
              {
                required: true,
                message: intl.get('hzero.common.validation.notNull', {
                  name: intl.get('hiam.userInfo.model.user.password').d('密码'),
                }),
              },
              {
                validator: (_, value, callback) => {
                  validatePasswordRule(value, callback, { ...passwordTipMsg, loginName });
                },
              },
              {
                validator: (_, value, callback) => {
                  this.validateNewPasswordNotSame(value, callback, form);
                },
              },
              {
                max: 110,
                message: intl.get('hzero.common.validation.max', {
                  max: 110,
                }),
              },
            ],
          })(
            <PasswordStrength
              onChange={(value) => {
                this.validatePasswordRepeatForPassword({ target: { value } }, form);
              }}
              onStrengthChange={(strength) => {
                // 密码强度变化时的处理
                this.setState({ passwordStrength: strength });
              }}
            />
          )}
        </FormItem>
        <FormItem
          required
          key="anotherPassword"
          label={intl.get('hiam.userInfo.model.user.anotherPassword').d('确认密码')}
          {...formItemLayout}
        >
          {getFieldDecorator('anotherPassword', {
            rules: [
              {
                required: true,
                message: intl.get('hzero.common.validation.notNull', {
                  name: intl.get('hiam.userInfo.model.userInfo.anotherPassword').d('确认密码'),
                }),
              },
              {
                validator: (_, value, callback) => {
                  this.validatePasswordAnther(value, callback, form);
                },
              },
            ],
          })(<Input type="password" />)}
        </FormItem>
      </Modal>
    );
  }
}

// 密码是否过期
function passwordExpired() {
  return request(`${HZERO_IAM}/hzero/v1//users/self/password-expired`, {
    method: 'GET',
  });
}

// 更新密码
async function userInfoUpdatePassword({ password, originalPassword }) {
  return request(`${HZERO_IAM}/hzero/v1/users/password`, {
    method: 'PUT',
    body: {
      originalPassword,
      password,
    },
  });
}

function getPasswordRule() {
  return request(`${HZERO_IAM}/v1/${getCurrentOrganizationId()}/password-policies/query`, {
    method: 'GET',
  });
}
